import { Counter } from './components/counter';
// import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
     <Counter/>
    </div>
  );
}

export default App;
